export const CopyCustomFieldService = Symbol('CopyCustomFieldService');
